module.exports = __webpack_public_path__ + "static/media/robinThicke.b9f1e56e.jpg";